import React from 'react';

const categories = () => (
  <div />
);

export default categories;
